import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import ImageR from '../assets/img/Icons/Icons/image.png'

import ImageQ from '../assets/img/Icons/Icons/imageQ.png'
import ImageC from '../assets/img/Icons/Icons/imagechat.png'

import Barside from '../assets/img/Icons/Icons/Icon-17.png'
import Barcodes from '../assets/img/Icons/Icons/checkoutbarcode.png'
import Footer from '../pages/footer'

import MainImgSmall from '../assets/img/Icons/Icons/smallimgicon.png'

const Checkout = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">
                        <div className="col-sm-1-my17 ">
                            <Sidebar/>
                        </div>
                        <div className="col-sm-11-my17 text-center ">

                            <h5 className=" signin1-h1-top  mb-0">Card</h5>
                        </div>

                    </div>

                    <div className="row page17-p">
                        <div className="col-sm-12 py-2">
                            <hr className="mt-2" />

                            <div className="row text-center">
                                <div className="col-sm-12">
                                    <img src={MainImgSmall} alt="" height={40} width={50} className="mt-4" />
                                    <p className="mb-1 mt-3"><small className="fw600">9856426395</small></p>
                                    <h5 className="text-danger fw600 mb-3">Card Username</h5>
                                    <p className="text-uppercase mb-1"><small className="fw600">Scan this barcode at checkout</small></p>
                                    <div>
                                        <img src={Barcodes} className="checkout-barcode-CN px-5" alt="" />
                                    </div>
                                    <h6 className="text-dark fw600 mt-5">Congrats!</h6>

                                    <h6 className="text-dark fw600">You have saved</h6>
                                    <div className="px-5">
                                        <Link to="/Register1" type="button" className="btn btn-outline-success w-100 mt-5 pt-4 pb-3" ><h5 className="fw600">$100.00</h5></Link>

                                    </div>
                                </div>
                            </div>
                
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default Checkout;

